import { jsx as _jsx } from "react/jsx-runtime";
import { Tile } from '../../ui/Tile';
import { StyledList, StyledListItem, StyledWrapper, } from './CollectionTiles.style';
export const CollectionTilesVariants = ['grid', 'list'];
const getTilesVariant = (variant) => {
    if (variant === 'grid') {
        return 'inline';
    }
    return 'full';
};
export function CollectionTiles({ columns = 2, tiles, variant, }) {
    return (_jsx(StyledWrapper, { children: _jsx(StyledList, { variant: getTilesVariant(variant), columns: columns, children: tiles.map((tile) => (_jsx(StyledListItem, { variant: getTilesVariant(variant), children: _jsx(Tile, Object.assign({}, tile, { variant: getTilesVariant(variant) })) }, `tile-${tile.label}-${tile.imageUrl}`))) }) }));
}
//# sourceMappingURL=CollectionTiles.js.map